/**
 * Tabs Fuctionality
 *
 * @since   1.0.0
 * @package acs-calc
 */

(function($) {

	// set tabs to active state
	$('#calc-btn-tab-links > li').on('click', function(e)  {

		// Change/remove current tab to active
		$(this).addClass('active').siblings().removeClass('active');

		e.preventDefault();
	});

	// logic for either or surface area options required
	var surfaceArea = $('#acs-surfacearea-input');
	var widthLength = $('#acs-width-input,#acs-length-input');

    surfaceArea.on('input', function () {
        // Set the required property of the other input to false if this input is not empty.
        widthLength.prop('required', !$(this).val().length);
    });

    widthLength.on('input', function () {
        // Set the required property of the other input to false if this input is not empty.
        surfaceArea.prop('required', !$(this).val().length);
    });

})(jQuery);